/**
 * Task de convite de teleconsultoria.
 * Mesmo CodeSystem das demais notificações (`task-types`), com code próprio.
 */
export const INVITE_TASK_CODE_SYSTEM =
  "https://fluxmed.com.br/fhir/CodeSystem/task-types";
export const INVITE_TASK_CODE = "TELECONSULTORIA_INVITE";
export const INVITE_TASK_CODE_TEXT = "Convite de teleconsultoria";

/**
 * `Task.identifier` com a organização PRESTADORA (organização do convidado).
 * É por ele que a clínica prestadora lista os convites dos seus profissionais.
 * Convites criados antes deste identifier não aparecem nessa visão.
 */
export const INVITE_PROVIDER_IDENTIFIER_SYSTEM =
  "https://fluxmed.com.br/fhir/identifier/teleconsultoria-provider";

/**
 * `Task.identifier` com o id lógico do Appointment de origem.
 * O Appointment fica em OUTRO servidor (scheduling/ehr): uma referência direta
 * (`focus: Appointment/{id}`) faz o HAPI do workflow tentar resolvê-la e responder 500.
 * Mesmo NamingSystem usado pelas tasks de questionário.
 */
export const INVITE_APPOINTMENT_IDENTIFIER_SYSTEM =
  "https://fluxmed.com.br/fhir/NamingSystem/scheduling-appointment-id";

/** Tipos de `Task.input` gravados no convite. */
export const INVITE_INPUT_SYSTEM =
  "https://fluxmed.com.br/fhir/CodeSystem/teleconsultoria-invite-input";
export const INVITE_INPUT = {
  guestPractitioner: "guest-practitioner",
  guestHealthcareService: "guest-healthcare-service",
  patient: "patient",
  inviteKind: "invite-kind",
} as const;

/**
 * Tipo do convite (input `invite-kind`, valueCode):
 * - scheduled: reserva da afiliada com horário marcado (aceitar NÃO abre o atendimento);
 * - now: reserva "Agora" da afiliada (aceitar e entrar);
 * - in-progress: convite feito dentro de um atendimento aberto (ActionBar/evolução).
 * Task sem o input = in-progress (convites criados antes deste campo).
 */
export type InviteKind = "scheduled" | "now" | "in-progress";
export const DEFAULT_INVITE_KIND: InviteKind = "in-progress";

/** Sala com atendimento já vencido: o convite vale por mais este tempo. */
export const INVITE_FALLBACK_VALIDITY_IN_MINUTES = 60;

/**
 * Notificação para QUEM CONVIDOU quando o convidado aceita ou recusa.
 * Task comum de notificação (mesmo CodeSystem), lida/não lida na central.
 */
export const INVITE_RESPONSE_TASK_CODE = "TELECONSULTORIA_INVITE_RESPONSE";
export const INVITE_RESPONSE_TEXT = {
  accepted: "Teleconsultoria aceita",
  rejected: "Teleconsultoria recusada",
} as const;
export type InviteResponse = keyof typeof INVITE_RESPONSE_TEXT;

/** Status que o convite pode ter. "requested" = aguardando resposta. */
export type InviteTaskStatus =
  | "requested"
  | "accepted"
  | "rejected"
  | "cancelled";

/** Status exibidos na central de notificações para o convite. */
export const INVITE_TASK_STATUSES: ReadonlySet<string> = new Set<InviteTaskStatus>([
  "requested",
  "accepted",
  "rejected",
  "cancelled",
]);
